import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import BackupPanel from "@/components/app/BackupPanel";
import { useAuth } from "@/contexts/AuthContext";

/** Standalone dialog wrapper around BackupPanel, opened from the sidebar
 *  "Backup" entry so admins/coaches don't have to hunt inside Profile.
 *  Header copy adapts to the viewer's role — athletes shouldn't see
 *  gym-wide phrasing when the panel below only offers a self-export. */
export default function BackupDialog({ open, onOpenChange }) {
  const { user } = useAuth();
  const isCoach = user?.role === "admin" || user?.role === "coach";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl max-w-lg max-h-[90vh] overflow-y-auto" data-testid="backup-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">
            {isCoach ? "Backup & restore" : "Backup my data"}
          </DialogTitle>
          <DialogDescription>
            {isCoach
              ? "Download or restore all training data for your gym."
              : "Download every workout, program, and check-in on your account."}
          </DialogDescription>
        </DialogHeader>
        <div className="pt-2">
          <BackupPanel />
        </div>
      </DialogContent>
    </Dialog>
  );
}
